import {Grid} from "@mui/material";
import styles from 'assets/css/BarChartStyle.module.css'

export const BarChartHeader = () => (
    <Grid container className={`${styles.headerContainer} ${styles.pdfHeaderContainer}`}>
        <Grid item xs={3}>
            <p className={styles.textHeader}>ساعت</p>
        </Grid>
        <Grid item xs={5}>
            <p className={styles.textHeader}>امتیاز در محدوده</p>
        </Grid>
        <Grid item xs={1.5}>
            <p className={styles.textHeader}>میانگین</p>
        </Grid>
        <Grid item xs={2.5}>
            <p className={styles.textHeader}>تعدادتست ها</p>
        </Grid>
    </Grid>
)
